import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { useMutation } from "@/modules/api/hooks/useMutation";
import { apiErrorValidate } from "@/modules/api/utils/apiErrorValidate";
import { setupPasswordMutation } from "@/modules/auth/api/mutations/setupPassword/setupPasswordMutation";
import { anonymousRouting } from "@/modules/router/routings/anonymousRouting";

const translationNamespace = "apiMessages/useSetupPasswordMutation";

export const useSetPasswordMutation = () => {
  const history = useHistory();
  const jsonApi = useJsonApi();
  const { t } = useTranslation(translationNamespace);

  return useMutation([setupPasswordMutation.name], {
    mutationFn: setupPasswordMutation(jsonApi),
    onSuccess: () => {
      history.replace(anonymousRouting.buildUrl("setupPasswordSuccess"));
    },
    onError: (error) => {
      apiErrorValidate(error, {
        401: {
          UNAUTHORIZED: t(
            "You are not allowed to set up the password. Please try again or contact the administrator"
          ),
        },
        404: {
          ACCOUNT_NOT_FOUND: t(
            "Account cannot be found, pleace contact the administrator"
          ),
        },
        422: {
          COMMON_PASSWORD: t(
            "Your password is too easy to guess, please try another one"
          ),
        },
      });
    },
    retry: false,
  });
};
